// @ts-nocheck
import { AttributeTypeModel } from "@insite/client-framework/Types/ApiModels";

export const attributesCalculation = (limitedAttributeTypes: AttributeTypeModel[]) => {
    const array = [];
    const filteredAttr = limitedAttributeTypes;
    if (filteredAttr.length <= 7) {
        array.push(filteredAttr);
        return array;
    }

    for (let i = 0; i < filteredAttr.length; i += Math.ceil(filteredAttr.length / 2)) {
        array.push(filteredAttr.slice(i, i + Math.ceil(filteredAttr.length / 2)));
    }
    return array;
};
